var map = {
	"./add-new-32.svg": 83077,
	"./airplane.svg": 34289,
	"./algorithm.svg": 26866,
	"./answers-24.svg": 2683,
	"./app-store-apple.svg": 25383,
	"./app-store-google.svg": 54424,
	"./appearance-24.svg": 46932,
	"./appstore.svg": 83819,
	"./arrow-angle-16.svg": 68692,
	"./arrow-calendar.svg": 44957,
	"./arrow-down-16.svg": 61429,
	"./arrow-in-a-circle-left-32.svg": 82033,
	"./arrow-in-a-circle-right-32.svg": 43642,
	"./arrow-in-an-outlined-circle-right-32.svg": 28955,
	"./arrow-open-right-16.svg": 97310,
	"./arrow-right-16.svg": 47653,
	"./arrow-right-small-24.svg": 46440,
	"./arrow-up-16.svg": 24572,
	"./attention-24.svg": 51482,
	"./attention-red.svg": 55021,
	"./attention-white-24.svg": 7850,
	"./back-new.svg": 96879,
	"./back.svg": 5306,
	"./bank-24.svg": 46076,
	"./bank-statement-100.svg": 86891,
	"./bank_statement.svg": 11619,
	"./bar_chart.svg": 68823,
	"./bar_chart_new.svg": 26704,
	"./bars.svg": 11941,
	"./bell-24.svg": 72431,
	"./bill.svg": 59576,
	"./blank.svg": 22511,
	"./briefcase-service-tabs.svg": 64628,
	"./briefcase.svg": 87069,
	"./calendar-64.svg": 65656,
	"./calendar-in-circle.svg": 1380,
	"./calendar.svg": 29401,
	"./chart-new.svg": 57352,
	"./chart.svg": 1493,
	"./check-16.svg": 2495,
	"./checkmark.svg": 11298,
	"./checkmark_big_green.svg": 66733,
	"./checkmark_in_a_circle.svg": 52567,
	"./checkmark_in_a_thin_round.svg": 23851,
	"./checkmark_in_a_thin_round_thin.svg": 87635,
	"./checkmark_small.svg": 7094,
	"./chevron-right-16.svg": 39667,
	"./chevron.svg": 82964,
	"./chevron_right.svg": 4067,
	"./chevron_right_bold.svg": 44415,
	"./circle-24.svg": 650,
	"./clear-cross.svg": 19141,
	"./clear.svg": 98434,
	"./click.svg": 30809,
	"./clock-24.svg": 57406,
	"./clock.svg": 64219,
	"./coin.svg": 74472,
	"./coins-24.svg": 54430,
	"./completed-16.svg": 8502,
	"./copy-24.svg": 80867,
	"./cross-16.svg": 84955,
	"./cross-24.svg": 80096,
	"./cross-thin.svg": 31383,
	"./cross.svg": 2757,
	"./csv-32.svg": 19761,
	"./cup.svg": 71113,
	"./dashboard-down-24.svg": 60149,
	"./dashboard-hide-24.svg": 89133,
	"./dashboard-trash-delete-bin-24.svg": 99871,
	"./dashboard-up-24.svg": 17908,
	"./dashboard.svg": 38277,
	"./date-picker.svg": 97742,
	"./delete-16.svg": 29822,
	"./diagram.svg": 26222,
	"./directDebit.svg": 17522,
	"./disable-2fa.svg": 61591,
	"./diy-desktop.svg": 76420,
	"./diy-mobile.svg": 18058,
	"./doc.svg": 32819,
	"./document-24.svg": 66195,
	"./document.svg": 51208,
	"./done-new-32.svg": 11396,
	"./dots-menu.svg": 71461,
	"./down.svg": 83483,
	"./earth.svg": 19945,
	"./envelope.svg": 6451,
	"./essential/dots-menu-light.svg": 24887,
	"./essential/dots-menu.svg": 37804,
	"./exclamation-triangle.svg": 64239,
	"./exclamation.svg": 9174,
	"./expert-professional.svg": 5317,
	"./facebook.svg": 19335,
	"./file-64.svg": 51636,
	"./filled-success-24.svg": 6020,
	"./fingerprint.svg": 19693,
	"./flag-checkers.svg": 53630,
	"./flag.svg": 63625,
	"./gift-40.svg": 96554,
	"./gift-in-circle-40.svg": 27693,
	"./globally-diversified.svg": 67692,
	"./good-64.svg": 38659,
	"./google-play.svg": 79209,
	"./googleplus.svg": 86306,
	"./graph.svg": 94417,
	"./growth-type-choose.svg": 69224,
	"./growth.svg": 10510,
	"./growth_chart.svg": 45467,
	"./hand-service-tabs.svg": 25067,
	"./hand.svg": 52908,
	"./hedged-16.svg": 20190,
	"./hedged-32.svg": 78364,
	"./help-24.svg": 36981,
	"./hidden-24.svg": 67258,
	"./horizontal-logo.svg": 74101,
	"./income-type-choose.svg": 70995,
	"./information-12.svg": 58181,
	"./information-16.svg": 65193,
	"./information-24.svg": 6414,
	"./information-54.svg": 96127,
	"./information-new-24.svg": 59545,
	"./instantBankTransfer.svg": 56065,
	"./intelligent-design.svg": 41249,
	"./ios/analytics.svg": 51391,
	"./ios/back.svg": 64704,
	"./ios/chart-new.svg": 74014,
	"./ios/chevron_right_bold.svg": 70485,
	"./ios/dashboard_active.svg": 41052,
	"./ios/more.svg": 24318,
	"./ios/more_active.svg": 6835,
	"./ios/pencil.svg": 76858,
	"./ios/reports.svg": 49194,
	"./ios/reports_active.svg": 27783,
	"./ios/settings.svg": 73574,
	"./ios/settings_active.svg": 16075,
	"./ios/support.svg": 30222,
	"./ios/support_active.svg": 16099,
	"./ios/transactions.svg": 87466,
	"./ios/transactions_active.svg": 72007,
	"./iphone.svg": 22244,
	"./isa-64.svg": 89567,
	"./isa-declararion-64.svg": 63664,
	"./isa-type-choose.svg": 43277,
	"./jump.svg": 7075,
	"./laptop-service-tabs.svg": 92774,
	"./laptop-square.svg": 2257,
	"./laptop.svg": 88075,
	"./leaf-16.svg": 18513,
	"./leaf-32.svg": 58231,
	"./left.svg": 58716,
	"./linkedin.svg": 86305,
	"./logo-16.svg": 15006,
	"./logo-48.svg": 69119,
	"./logo-small-new.svg": 93453,
	"./logo-small.svg": 72904,
	"./logo.svg": 4546,
	"./logout-24.svg": 54352,
	"./long-term.svg": 52756,
	"./mail.svg": 81878,
	"./managed-desktop.svg": 72825,
	"./managed-mobile.svg": 40189,
	"./manualBankTransfer.svg": 74266,
	"./menu.svg": 63490,
	"./messages.svg": 11291,
	"./mid-term.svg": 62210,
	"./money-around.svg": 92813,
	"./money-stack.svg": 47286,
	"./more-24.svg": 33271,
	"./new-copy-24.svg": 53602,
	"./next-arrow.svg": 61368,
	"./number_1.svg": 29688,
	"./number_2.svg": 68523,
	"./number_3.svg": 63258,
	"./one-32.svg": 21473,
	"./passport-100.svg": 68471,
	"./passport.svg": 97821,
	"./pdf-32.svg": 27175,
	"./pdf.svg": 3267,
	"./pencil-24.svg": 96099,
	"./pencil.svg": 19096,
	"./people-24.svg": 34513,
	"./person-professional.svg": 25748,
	"./person.svg": 38884,
	"./person2.svg": 40062,
	"./personal-type-choose.svg": 3930,
	"./phone.svg": 36553,
	"./pie.svg": 85899,
	"./piechart-104.svg": 3891,
	"./piechart-16.svg": 62475,
	"./piechart-24.svg": 26768,
	"./play.svg": 18133,
	"./plus-16.svg": 81561,
	"./plus-in-a-circle-24.svg": 57115,
	"./plus-in-an-outlined-circle-32.svg": 48827,
	"./plus.svg": 79355,
	"./pound-16.svg": 45681,
	"./pound-32.svg": 85399,
	"./pound-flag.svg": 5602,
	"./pound-in-circle.svg": 73102,
	"./prev-arrow.svg": 5048,
	"./profile-photo-widget-100.svg": 89176,
	"./proven-methodology.svg": 87649,
	"./question-24.svg": 63766,
	"./question-in-bubble-80.svg": 53217,
	"./question.svg": 81171,
	"./questionInCircle.svg": 50254,
	"./questionInCircleNoColor.svg": 68804,
	"./questionmark-24.svg": 36927,
	"./quote.svg": 71321,
	"./rebalancing.svg": 14881,
	"./refresh-24.svg": 75563,
	"./repeat-16.svg": 69878,
	"./repeat-32.svg": 35828,
	"./right.svg": 4643,
	"./round-pound.svg": 72676,
	"./safe.svg": 7668,
	"./scheme.svg": 1442,
	"./search.svg": 72775,
	"./selfie-100.svg": 20861,
	"./selfie.svg": 52275,
	"./settings-24.svg": 65935,
	"./share-chart.svg": 80991,
	"./share.svg": 51604,
	"./shield-48.svg": 61373,
	"./short-term.svg": 58690,
	"./smarter-returns.svg": 2409,
	"./smartphone-stat-square.svg": 76451,
	"./smartphone-stat.svg": 40081,
	"./smartphone.svg": 40226,
	"./sort-high-16.svg": 5504,
	"./sort-low-16.svg": 68754,
	"./ssl256.svg": 48458,
	"./starling.svg": 92455,
	"./steps.svg": 33208,
	"./stop-64.svg": 64722,
	"./stroked-placeholder.svg": 59817,
	"./subtract-16.svg": 55989,
	"./subtract-24.svg": 97274,
	"./success-24.svg": 28007,
	"./success-48.svg": 11181,
	"./success-64.svg": 65171,
	"./target.svg": 6244,
	"./tax-info.svg": 78275,
	"./ter-16.svg": 25720,
	"./ter-32.svg": 40474,
	"./thin-equal.svg": 75889,
	"./thin-mail.svg": 36078,
	"./thin-plus.svg": 26259,
	"./time-24.svg": 54483,
	"./time-32.svg": 43390,
	"./time-48.svg": 50025,
	"./time-64.svg": 46439,
	"./time-alt-24.svg": 9,
	"./time-in-circle-64.svg": 74256,
	"./transfer.svg": 94046,
	"./transparent-and-accessible.svg": 29902,
	"./triangle.svg": 63059,
	"./twitter.svg": 43344,
	"./two-32.svg": 75587,
	"./up.svg": 43796,
	"./update.svg": 56144,
	"./user-24.svg": 69853,
	"./user-avatar-36.svg": 67650,
	"./user-settings-24.svg": 60391,
	"./warning-64.svg": 33568,
	"./warning-circle-64.svg": 36877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8826;